export function initCart() {
    if (!$('.id--16').length) {
        return
    }

    const changedManually = parseInt(localStorage.getItem('changedManually')) || 0
    if (changedManually > 0) {
        localStorage.setItem('changedManually', 0)
        return
    }

    changeCountryIfSlovakia()

    document.addEventListener('ShoptetDeliveryZipPatternChange', () => {
        if (!isProgrammaticChange) {
            const currentCount = parseInt(localStorage.getItem('changedManually')) || 0
            localStorage.setItem('changedManually', currentCount + 1)
        }
    })
}

function changeCountryIfSlovakia() {
    const countrySelect = $('#deliveryCountryId').val()
    const paymentCurrency = $('#payment-currency').val()
    const isCzechUser = detectUserByCountry(COUNTRY_CONFIGS.czech) || document.documentElement.lang === 'cs'
    const isSlovakUser = detectUserByCountry(COUNTRY_CONFIGS.slovak) || document.documentElement.lang === 'sk'
    const czCountryId = '43'
    const skCountryId = '151'

    // Handle Slovak users
    if (isSlovakUser) {
        if (paymentCurrency === 'CZK') {
            setCzCountry()
            return
        }

        if (countrySelect !== skCountryId || paymentCurrency !== 'EUR') {
            setSkCountry()
        }
        return
    }

    // Handle Czech users
    if (isCzechUser) {
        if (paymentCurrency === 'EUR') {
            setSkCountry()
            return
        }

        if (countrySelect !== czCountryId || paymentCurrency === 'CZK') {
            setCzCountry()
        }

        return
    }

    // Fallback to geolocation
    fetchGeolocationData()
}

let isProgrammaticChange = false

function setCountry(countryId) {
    setTimeout(() => {
        isProgrammaticChange = true
        $('#deliveryCountryId').val(countryId).focus().trigger('click').trigger('change').blur()
        isProgrammaticChange = false
    }, 10)
}

function setSkCountry() {
    setCountry('151')
}

function setCzCountry() {
    setCountry('43')
}

function detectUserByCountry(countryConfig) {
    const browserLang = navigator.language || navigator.userLanguage
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const userLocale = navigator.languages || []

    const signals = [
        ...countryConfig.langCodes.map((code) => browserLang.includes(code)),
        timezone === countryConfig.timezone,
        ...countryConfig.langCodes.map((code) => userLocale.some((locale) => locale.includes(code))),
    ]

    return signals.filter(Boolean).length >= 2
}

async function fetchGeolocationData() {
    const requestOptions = {
        method: 'GET',
    }

    try {
        const response = await fetch(
            'https://api.geoapify.com/v1/ipinfo?&apiKey=e815f2609ce64163a08456e1ae4a323e',
            requestOptions
        )
        const result = await response.json()

        if (result?.country?.name === 'Slovakia') {
            setSkCountry()
        }
    } catch (error) {
        console.log('error', error)
    }
}

const COUNTRY_CONFIGS = {
    slovak: {
        langCodes: ['sk'],
        timezone: 'Europe/Bratislava',
    },
    czech: {
        langCodes: ['cs', 'cz'],
        timezone: 'Europe/Prague',
    },
}
